// extracted by mini-css-extract-plugin
export default {"centered":"Faqs_centered__NtIW+","icon":"Faqs_icon__oCzKY","discordBtn":"Faqs_discordBtn__R+UgU","main_faqs":"Faqs_main_faqs__5Xve6","faqs_head":"Faqs_faqs_head__6Npnn"};